const sliderInit = (isUpdate) => {
  if (document.querySelectorAll('.js-media-list') && document.querySelectorAll('.js-media-list').length > 0) {
    document.querySelectorAll('.js-media-list').forEach((elem, index) => {
      const mobileDirection = elem.dataset.direction || 'vertical'
      const directionDesc = elem.dataset.direction_desc || elem.dataset.directionDesc || mobileDirection
      const sliderType = elem.dataset.sliderType

      const desktopMousewheelEnabled = directionDesc !== 'horizontal'
      const mobileMousewheelEnabled = mobileDirection !== 'horizontal'
      const isDesktopViewport = window.innerWidth >= 750
      const initialDirection = isDesktopViewport ? directionDesc : mobileDirection
      let mousewheel = isDesktopViewport ? desktopMousewheelEnabled : mobileMousewheelEnabled

      let slider = new Swiper(elem, {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        mousewheel: {
          enabled: mousewheel
        },
        direction: initialDirection,
        speed: 500,
        //loop: false,
        //observeParents: true,
        //freeMode: {
        //	enabled: !!elem
        //		.closest(".product__outer")
        //		.classList.contains("product__outer--multiple-top"),
        //	sticky: true,
        //},
        breakpoints: {
          750: {
            mousewheel: {
              enabled: desktopMousewheelEnabled
            },
            direction: directionDesc
          }
        },
        navigation: {
          nextEl: '.product .product__slider-nav .swiper-button-next',
          prevEl: '.product .product__slider-nav .swiper-button-prev'
        },
        pagination: {
          el: '.product .product__pagination',
          type: 'bullets',
          clickable: true
        },
        thumbs: {
          swiper: elem.nextElementSibling.querySelector('.js-media-sublist')
            ? elem.nextElementSibling.querySelector('.js-media-sublist').swiper
            : ''
        },
        on: {
          //afterInit: function (swiper) {
          //	if (document.querySelector(".product__outer--multiple-top")) {
          //		document
          //			.querySelectorAll(".product__media-toggle")
          //			.forEach((elem, index) => {
          //				elem.addEventListener("click", (e) => {
          //					var target = e.currentTarget;

          //					if (
          //						document.querySelector(".js-popup-slider") &&
          //						document.querySelector(".js-popup-slider").swiper
          //					) {
          //						document
          //							.querySelector(".js-popup-slider")
          //							.swiper.slideTo(index);
          //					}
          //				});
          //			});
          //	}
          //},
          slideChangeTransitionStart: function () {
            if (document.querySelector('.js-media-sublist')) {
              document
                .querySelector('.js-media-sublist')
                .swiper.slideTo(document.querySelector('.js-media-list').swiper.activeIndex)
            }
          },
          slideChange: function () {
            window.pauseAllMedia()
            this.params.noSwiping = false

            //if (
            //	document.querySelector(".js-popup-slider") &&
            //	document.querySelector(".js-popup-slider").swiper &&
            //	!document.querySelector(".product__outer--multiple-top")
            //) {
            //	document
            //		.querySelector(".js-popup-slider")
            //		.swiper.slideTo(this.activeIndex);
            //}
          },
          slideChangeTransitionEnd: function () {
            if (this.slides[this.activeIndex].querySelector('model-viewer')) {
              this.slides[this.activeIndex]
                .querySelector('.shopify-model-viewer-ui__button--poster')
                .removeAttribute('hidden')
            }
          },
          touchStart: function () {
            if (this.slides[this.activeIndex].querySelector('model-viewer')) {
              if (
                !this.slides[this.activeIndex]
                  .querySelector('model-viewer')
                  .classList.contains('shopify-model-viewer-ui__disabled')
              ) {
                this.params.noSwiping = true
                this.params.noSwipingClass = 'swiper-slide'
              } else {
                this.params.noSwiping = false
              }
            }
          },
          resize: function () {
            const sliderInstance = this
            const isDesktop = window.innerWidth >= 750
            const desiredDirection = isDesktop ? directionDesc : mobileDirection
            const shouldEnableMousewheel = isDesktop ? desktopMousewheelEnabled : mobileMousewheelEnabled

            if (sliderInstance.params.direction !== desiredDirection) {
              sliderInstance.changeDirection(desiredDirection, false)
            }

            if (sliderInstance.params.mousewheel) {
              sliderInstance.params.mousewheel.enabled = shouldEnableMousewheel
              if (sliderInstance.mousewheel) {
                if (shouldEnableMousewheel) {
                  sliderInstance.mousewheel.enable()
                } else {
                  sliderInstance.mousewheel.disable()
                }
              }
            }

            sliderInstance.update()
          }
        }
      })

      const syncSliderOrientation = () => {
        const isDesktop = window.innerWidth >= 750
        const desiredDirection = isDesktop ? directionDesc : mobileDirection
        const shouldEnableMousewheel = isDesktop ? desktopMousewheelEnabled : mobileMousewheelEnabled

        if (slider.params.direction !== desiredDirection) {
          slider.changeDirection(desiredDirection, false)
        }

        if (slider.params.mousewheel) {
          slider.params.mousewheel.enabled = shouldEnableMousewheel
          if (slider.mousewheel) {
            if (shouldEnableMousewheel) {
              slider.mousewheel.enable()
            } else {
              slider.mousewheel.disable()
            }
          }
        }

        slider.update()
      }

      syncSliderOrientation()

      //if (sliderType === "main-product") {
      //	optimizingVisibleSliderElements(
      //		elem,
      //		".product__media-item.swiper-slide"
      //	);
      //}

      if (isUpdate) {
        setTimeout(function () {
          syncSliderOrientation()
        }, 400)
      }
    })
  }
}

//function forceUpdateSwiperHeight(slider) {
//	const activeSlide = slider.slides[slider.activeIndex];
//	if (activeSlide) {
//		const height = activeSlide.querySelector(".product__media").offsetHeight;

//		slider.el.style.height = height + "px";
//		slider.wrapperEl.style.height = height + "px";
//	}
//}

function forceUpdateSwiperHeight() {
  const sliders = document.querySelectorAll('.js-media-list')
  sliders.forEach((sliderEl) => {
    const swiperInstance = sliderEl.swiper

    if (swiperInstance && swiperInstance.slides) {
      const activeSlide = swiperInstance.slides[swiperInstance.activeIndex]
      if (activeSlide) {
        const media = activeSlide.querySelector('.product__media')

        if (media) {
          const height = media.offsetHeight
          console.log(height)

          swiperInstance.wrapperEl.style.height = height + 'px'
        }
      }
    }
  })
}

window.addEventListener('resize', () => {
  setTimeout(function () {
    forceUpdateSwiperHeight()
  }, 100)
})

const subSliderInit = (isUpdate) => {
  if (document.querySelectorAll('.js-media-sublist') && document.querySelectorAll('.js-media-sublist').length > 0) {
    document.querySelectorAll('.js-media-sublist').forEach((elem, index) => {
      if (index >= 1) return

      const mobileDirection = elem.dataset.direction || 'vertical'
      const directionDesc = elem.dataset.direction_desc || elem.dataset.directionDesc || mobileDirection

      const initialDirection = window.innerWidth >= 750 ? directionDesc : mobileDirection
      const sliderType = elem.dataset.sliderType

      let subSlider = new Swiper(elem, {
        slidesPerView: 'auto',
        direction: initialDirection,
        freeMode: false,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        autoHeight: true,
        //loop: false,
        //observeParents: true,
        on: {
          afterInit: function () {
            //this.params.slidesPerView = this.slides.length === 2 ? 2 : 3;
          },
          touchEnd: function (s, e) {
            let range = 5
            let diff = (s.touches.diff = s.isHorizontal()
              ? s.touches.currentX - s.touches.startX
              : s.touches.currentY - s.touches.startY)
            if (diff < range || diff > -range) s.allowClick = true
          },
          resize: function () {
            const sliderInstance = this
            const desiredDirection = window.innerWidth >= 750 ? directionDesc : mobileDirection

            if (sliderInstance.params.direction !== desiredDirection) {
              sliderInstance.changeDirection(desiredDirection, false)
            }

            sliderInstance.update()
          }
        },
        breakpoints: {
          750: {
            direction: directionDesc
          }
        }
        //transitionStart: function () {
        //	document
        //		.querySelector(".js-media-list")
        //		.swiper.slideTo(
        //			document.querySelector(".js-media-sublist").swiper.activeIndex,
        //		);
        //},
        //breakpoints: {
        //	576: {
        //		direction: "vertical",
        //		slidesPerView: "auto",
        //	},
        //},
      })

      const syncSubSliderDirection = () => {
        const desiredDirection = window.innerWidth >= 750 ? directionDesc : mobileDirection

        if (subSlider.params.direction !== desiredDirection) {
          subSlider.changeDirection(desiredDirection, false)
          subSlider.update()
        }
      }

      syncSubSliderDirection()

      const sliderResizeObserve = new ResizeObserver((entries) => {
        const [entry] = entries
        setTimeout(() => {
          const sliders = document.querySelectorAll('.js-media-list')
          const thumbs = document.querySelectorAll('.product__media-sublist')
          if (sliders.length > 0 && thumbs.length > 0) {
            if (index >= 0 && index < sliders.length) {
              const sliderHeight = sliders[index].getBoundingClientRect().height
              thumbs[index].style.height = `${sliderHeight - 1}px`
            }
          }
        }, 400)
      })

      if (document.querySelector('.product-section'))
        sliderResizeObserve.observe(document.querySelector('.product-section'))

      //if (sliderType === "sub-product") {
      //	optimizingVisibleSliderElements(
      //		elem,
      //		".product__media-subitem.swiper-slide"
      //	);
      //}

      if (isUpdate) {
        setTimeout(function () {
          syncSubSliderDirection()
        }, 800)
      }
    })
  }
}

function optimizingVisibleSliderElements(sliderElement, sliderItemClass) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.visibility = 'visible'
        } else {
          entry.target.style.visibility = 'hidden'
        }
      })
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    }
  )

  sliderElement.querySelectorAll(sliderItemClass).forEach((slide) => {
    observer.observe(slide)
  })
}

function fetchCardSlideData(handle, isQuickAdd) {
  const selectors = {
    productCard: '.card-wrapper'
  }
  const cardStorageKey = isQuickAdd ? `quickAdd-${handle}` : handle
  let sessionCardSlide = sessionStorage.getItem(cardStorageKey)

  if (sessionCardSlide) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(sessionCardSlide, 'text/html')
    sessionCardSlide = doc.body.firstChild
  }

  if (sessionCardSlide) {
    console.log('%cFetched from session', 'color:yellow')
    return new Promise((resolve) => {
      resolve(sessionCardSlide)
    })
  }

  console.log('%cFetched from URL', 'color:green')
  return getDataFromShopifyUrl(handle)

  function getProductCardUrl(handle) {
    switch (true) {
      case isQuickAdd:
        return `/products/${handle}?view=quick-add`
      default:
        return `/products/${handle}?view=klevu-template`
    }
  }

  function getDataFromShopifyUrl(handle) {
    return new Promise((resolve, reject) => {
      fetch(getProductCardUrl(handle))
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser()
          const dom = parser.parseFromString(data, 'text/html')
          const card = dom.querySelector(selectors.productCard)

          if (!card) resolve(null)

          sessionStorage.setItem(cardStorageKey, card.outerHTML)
          resolve(card)
        })
        .catch((e) => {
          reject(e)
        })
    })
  }
}

const quickAddsliderInit = (isUpdate) => {
  if (document.querySelectorAll('.js-media-list') && document.querySelectorAll('.js-media-list').length > 0) {
    document.querySelectorAll('.js-media-list').forEach((elem, index) => {
      let slider = new Swiper(elem, {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        speed: 500,
        direction: 'horizontal',
        navigation: {
          nextEl: '.product .product__slider-nav .swiper-button-next',
          prevEl: '.product .product__slider-nav .swiper-button-prev'
        },
        pagination: {
          el: '.product .product__pagination',
          type: 'bullets',
          clickable: true
        },
        on: {
          // afterInit: function (swiper) {
          // 	if (document.querySelector(".product__outer--multiple-top")) {
          // 		document
          // 			.querySelectorAll(".product__media-toggle")
          // 			.forEach((elem, index) => {
          // 				elem.addEventListener("click", (e) => {
          // 					var target = e.currentTarget;

          // 					if (
          // 						document.querySelector(".js-popup-slider") &&
          // 						document.querySelector(".js-popup-slider").swiper
          // 					) {
          // 						document
          // 							.querySelector(".js-popup-slider")
          // 							.swiper.slideTo(index);
          // 					}
          // 				});
          // 			});
          // 	}
          // },
          // slideChangeTransitionStart: function () {
          // 	if (document.querySelector(".js-media-sublist")) {
          // 		document
          // 			.querySelector(".js-media-sublist")
          // 			.swiper.slideTo(
          // 				document.querySelector(".js-media-list").swiper.activeIndex,
          // 			);
          // 	}
          // },
          slideChange: function () {
            window.pauseAllMedia()
            this.params.noSwiping = false

            // if (
            // 	document.querySelector(".js-popup-slider") &&
            // 	document.querySelector(".js-popup-slider").swiper &&
            // 	!document.querySelector(".product__outer--multiple-top")
            // ) {
            // 	document
            // 		.querySelector(".js-popup-slider")
            // 		.swiper.slideTo(this.activeIndex);
            // }
          },
          slideChangeTransitionEnd: function () {
            if (this.slides[this.activeIndex].querySelector('model-viewer')) {
              this.slides[this.activeIndex]
                .querySelector('.shopify-model-viewer-ui__button--poster')
                .removeAttribute('hidden')
            }
          },
          touchStart: function () {
            if (this.slides[this.activeIndex].querySelector('model-viewer')) {
              if (
                !this.slides[this.activeIndex]
                  .querySelector('model-viewer')
                  .classList.contains('shopify-model-viewer-ui__disabled')
              ) {
                this.params.noSwiping = true
                this.params.noSwipingClass = 'swiper-slide'
              } else {
                this.params.noSwiping = false
              }
            }
          }
        }
      })

      if (isUpdate) {
        setTimeout(function () {
          slider.update()
        }, 800)
      }
    })
  }
}

const popupSliderInit = (isUpdate) => {
  if (document.querySelector('.js-popup-slider')) {
    //let popupSlider = new Swiper(document.querySelector(".js-popup-slider"), {
    //	slidesPerView: 1,
    //	//navigation: {
    //	//	nextEl: ".product-media-modal .product__slider-nav .swiper-button-next",
    //	//	prevEl: ".product-media-modal .product__slider-nav .swiper-button-prev",
    //	//},
    //	//pagination: {
    //	//	el: ".product-media-modal .product__pagination",
    //	//	type: "bullets",
    //	//	clickable: true,
    //	//},
    //	on: {
    //		afterInit: function () {
    //			if (
    //				document.querySelector(
    //					".product__outer--static-multicolumns-aside"
    //				) ||
    //				document.querySelector(".product__outer--static-column-aside")
    //			) {
    //				document
    //					.querySelectorAll(".product__media-list .product__media-toggle")
    //					.forEach((elem, index) => {
    //						elem.addEventListener("click", (e) => {
    //							if (
    //								document.querySelector(".js-popup-slider") &&
    //								document.querySelector(".js-popup-slider").swiper
    //							) {
    //								document
    //									.querySelector(".js-popup-slider")
    //									.swiper.slideTo(index);
    //							}
    //						});
    //					});
    //			}
    //		},
    //		slideChange: function () {
    //			window.pauseAllMedia();
    //			this.params.noSwiping = false;
    //			document
    //				.querySelector(".product-media-modal__content")
    //				.classList.remove("zoom");
    //		},
    //		touchMove: function () {
    //			document
    //				.querySelector(".product-media-modal__content")
    //				.classList.remove("zoom");
    //		},
    //		slideChangeTransitionEnd: function () {
    //			if (this.slides[this.activeIndex].querySelector("model-viewer")) {
    //				this.slides[this.activeIndex]
    //					.querySelector(".shopify-model-viewer-ui__button--poster")
    //					.removeAttribute("hidden");
    //			}
    //		},
    //		touchStart: function () {
    //			if (this.slides[this.activeIndex].querySelector("model-viewer")) {
    //				if (
    //					!this.slides[this.activeIndex]
    //						.querySelector("model-viewer")
    //						.classList.contains("shopify-model-viewer-ui__disabled")
    //				) {
    //					this.params.noSwiping = true;
    //					this.params.noSwipingClass = "swiper-slide";
    //				} else {
    //					this.params.noSwiping = false;
    //				}
    //			}
    //		},
    //	},
    //});

    if (isUpdate) {
      setTimeout(function () {
        //popupSlider.update();
      }, 800)
    }
  }
}

;(function () {
  const sidebar = () => {
    let pageNav = $('.product__media-sublist__sidebar-nav')

    if (pageNav.length > 0) {
      let pageNavList = pageNav.find('a')
      let adminBarHeight = 0

      let headings = []
      for (let i = 0; i < pageNavList.length; i++) {
        headings[i] = $($(pageNavList[i]).attr('href'))
      }

      $(pageNavList[0]).parent().addClass('active')

      pageNavList.on('click', function (e) {
        e.preventDefault()

        const targetId = $(this).attr('href')
        const targetElement = $(targetId)

        if (targetElement.length) {
          $('.product-media-modal__dialog').animate(
            {
              scrollTop: targetElement.position().top + $('.product-media-modal__dialog').scrollTop()
            },
            100
          )
        }
      })

      $('.product-media-modal__dialog').on('scroll', function () {
        for (let i = headings.length - 1; i >= 0; i--) {
          if ($(headings[i]).length > 0) {
            if ($(headings[i]).offset().top - 50 <= $(window).scrollTop() + adminBarHeight) {
              if (!$(pageNavList[i]).parent().hasClass('active')) {
                let hasActiveItem = false
                for (let j = i; j < headings.length; j++) {
                  if ($(pageNavList[j]).parent().hasClass('active')) {
                    hasActiveItem = true
                  }
                }

                if (!hasActiveItem) {
                  $(pageNavList[i]).parent().addClass('active')
                }
              } else {
                for (let j = 0; j < i; j++) {
                  $(pageNavList[j]).parent().removeClass('active')
                }
              }
            } else {
              if (i !== 0) {
                $(pageNavList[i]).parent().removeClass('active')
              }
            }
          }
        }
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    sidebar()
    document.addEventListener('shopify:section:load', function () {
      sidebar()
    })
  })
})()

if (navigator.userAgent.indexOf('iPhone') > -1) {
  document
    .querySelector('[name=viewport]')
    .setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1')
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button')
  summary.setAttribute('aria-expanded', 'false')

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
  })

  if (summary.closest('header-drawer')) return
  summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')
  summaryElement.setAttribute('aria-expanded', false)
  summaryElement.focus()
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus && elementToFocus.focus()
}

function pauseAllMedia() {
  document.querySelectorAll('.product__media-list .js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
  })
  document.querySelectorAll('.product__media-list .js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('.product__media-list video').forEach((video) => video.pause())
  document.querySelectorAll('.product__media-list product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus && !elementToFocus.classList.contains('card-focused')) elementToFocus.focus()
}

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach((button) => {
      this.setMinimumDisable()

      button.addEventListener('click', this.onButtonClick.bind(this))
    })

    var eventList = ['paste', 'input']

    for (event of eventList) {
      this.input.addEventListener(event, function (e) {
        const numberRegex = /^0*?[1-9]\d*$/

        if (numberRegex.test(e.currentTarget.value) || e.currentTarget.value === '') {
          e.currentTarget.value
        } else {
          e.currentTarget.value = 1
        }

        if (e.currentTarget.value === 1 || e.currentTarget.value === '') {
          this.previousElementSibling.classList.add('disabled')
        } else {
          this.previousElementSibling.classList.remove('disabled')
        }
      })
    }

    this.input.addEventListener('focusout', function (e) {
      if (e.currentTarget.value === '') {
        e.currentTarget.value = 1
      }
    })
  }

  setMinimumDisable() {
    if (this.input.value == 1) {
      this.querySelector('button[name="minus"]').classList.add('disabled')
    } else {
      this.querySelector('button[name="minus"]').classList.remove('disabled')
    }
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)

    this.setMinimumDisable()
  }
}

customElements.define('quantity-input', QuantityInput)

function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function throttle(func, delay) {
  let lastTime = 0

  return function (...args) {
    const now = Date.now()

    if (now - lastTime >= delay) {
      func.apply(this, args)
      lastTime = now
    }
  }
}

const serializeForm = (form) => {
  const obj = {}
  const formData = new FormData(form)
  for (const key of formData.keys()) {
    obj[key] = formData.get(key)
  }
  return JSON.stringify(obj)
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`
    }
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options['method'] || 'post'
  var params = options['parameters'] || {}

  var form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (var key in params) {
    var hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid)

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this))

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt?.getAttribute('data-provinces')
    var provinces = JSON.parse(raw || '{}')

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  }
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super()

    this.mainDetailsToggle = this.querySelector('details')
    const summaryElements = this.querySelectorAll('summary')
    this.addAccessibilityAttributes(summaryElements)

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)

    this.addEventListener('keyup', this.onKeyUp.bind(this))
    this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.bindEvents()
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    )
    this.querySelectorAll('button').forEach((button) => {
      if (this.querySelector('.toggle-scheme-button') === button) return
      if (this.querySelector('.header__localization-button') === button) return
      if (this.querySelector('button.header__localization-button') === button) return
      if (this.querySelector('button.header__localization-lang-button') === button) return
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    })
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute('role', 'button')
      element.setAttribute('aria-expanded', false)
      element.setAttribute('aria-controls', element.nextElementSibling.id)
    })
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openDetailsElement = event.target.closest('details[open]')
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement)
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const isOpen = detailsElement.hasAttribute('open')

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement)
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'))

      setTimeout(() => {
        detailsElement.classList.add('menu-opening')
      })
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })
    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening')
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open')
        details.classList.remove('menu-opening')
      })
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false)
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
      removeTrapFocus(elementToFocus)
      this.closeAnimation(this.mainDetailsToggle)
      this.header = this.header || document.querySelector('.shopify-section-header')
      const main = document.querySelector('main')
      if (
        main.querySelectorAll('.shopify-section')[0]?.classList.contains('section--has-overlay') &&
        !this.header.classList.contains('animate')
      ) {
        this.header.classList.add('color-background-1', 'color-background-2')
      }
      if (
        this.header.classList.contains('color-background-1') &&
        !this.header.classList.contains('shopify-section-header-sticky')
      ) {
        this.header.classList.add('color-background-2')
      }
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        //if (this.classList.contains("mobile-facets__wrapper"))
        //	this.closeMenuDrawer();
        //else this.closeMenuDrawer(event);
        this.closeMenuDrawer()
    })
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details')
    this.closeSubmenu(detailsElement)
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening')
    removeTrapFocus()
    this.closeAnimation(detailsElement)
  }

  closeAnimation(detailsElement) {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute('open')
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'))
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.shopify-section-header')
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    )

    if (
      this.header.classList.contains('color-background-2') &&
      !this.header.classList.contains('shopify-section-header-sticky')
    ) {
      this.header.classList.remove('color-background-2')
    }

    const main = document.querySelector('main')
    if (main.querySelectorAll('.shopify-section')[0]?.classList.contains('section--has-overlay')) {
      this.header.classList.remove('color-background-2')
    }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })

    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }
}

customElements.define('header-drawer', HeaderDrawer)

class SearchModal extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
    this.querySelector('#SearchModal-Overlay').addEventListener('click', this.close.bind(this))

    this.querySelector('#search-modal-close').addEventListener('click', this.close.bind(this))
    this.setHeaderCartIconAccessibility()
  }

  setHeaderCartIconAccessibility() {
    if (document.querySelector('#search-icon-open') != null) {
      const cartLink = document.querySelector('#search-icon-open')
      cartLink.setAttribute('role', 'button')
      cartLink.setAttribute('aria-haspopup', 'dialog')
      cartLink.addEventListener('click', (event) => {
        event.preventDefault()
        this.open(cartLink)
      })
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault()
          this.open(cartLink)
        }
      })
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy)
    setTimeout(() => {
      this.classList.add('animate', 'active')
    })

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('search-modal')
        const focusElement =
          this.querySelector('.header__search input:not([type="hidden"])') ||
          this.querySelector('.search__main') ||
          this.querySelector('.search__close')
        trapFocus(containerToTrapFocusOn, focusElement)
      },
      { once: true }
    )

    document.body.classList.add('overflow-hidden')
  }

  close() {
    this.classList.remove('active')
    removeTrapFocus(this.activeElement)
    document.body.classList.remove('overflow-hidden')

    this.classList.add('hiding')

    setTimeout(() => this.classList.remove('hiding'), 700)
  }

  setActiveElement(element) {
    this.activeElement = element
  }
}

customElements.define('search-modal', SearchModal)

class accountModal extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
    this.querySelector('#accountModal-Overlay').addEventListener('click', this.close.bind(this))

    this.querySelector('#account-modal-close').addEventListener('click', this.close.bind(this))
    this.setHeaderCartIconAccessibility()
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#account-icon-open')
    cartLink.setAttribute('role', 'button')
    cartLink.setAttribute('aria-haspopup', 'dialog')
    cartLink.addEventListener('click', (event) => {
      event.preventDefault()
      this.open(cartLink)
    })
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault()
        this.open(cartLink)
      }
    })
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy)
    setTimeout(() => {
      this.classList.add('animate', 'active')
    })

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('account-modal')
        const focusElement = this.querySelector('.account__main') || this.querySelector('.account__close')
        trapFocus(containerToTrapFocusOn, focusElement)
      },
      { once: true }
    )

    document.body.classList.add('overflow-hidden')
  }

  close() {
    this.classList.remove('active')
    removeTrapFocus(this.activeElement)
    document.body.classList.remove('overflow-hidden')

    this.classList.add('hiding')

    setTimeout(() => this.classList.remove('hiding'), 700)
  }

  setActiveElement(element) {
    this.activeElement = element
  }
}

customElements.define('account-modal', accountModal)

class ModalDialog extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('click', (event) => {
      if (event.target.closest('[id^="ModalClose-"], #ModalApplyClose')) {
        this.hide(false)
      }
    })

    this.addEventListener('keyup', (event) => {
      if (event.code?.toUpperCase() === 'ESCAPE') this.hide()
    })
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide()
      })
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide()
      })
    }
  }

  connectedCallback() {
    if (this.moved) return
    this.moved = true
    document.body.appendChild(this)
  }

  show(opener) {
    this.openedBy = opener
    const popup = this.querySelector('.template-popup')
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    if (popup) popup.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
    //window.pauseAllMedia();
  }

  hide(isProductPage = false) {
    let isOpen = false

    this.removeAttribute('open')
    this.classList.add('hiding')

    if (!isProductPage) {
      removeTrapFocus(this.openedBy)
    }

    //window.pauseAllMedia();

    document.querySelectorAll('body > quick-add-modal').forEach((el) => {
      if (el.hasAttribute('open')) {
        isOpen = true
      }
    })

    let CartDrawerNote = document.getElementById('CartDrawer-Note')
    let CartDrawerNoteAppla = document.getElementById('CartDrawer-Note-Applay')

    if (!isOpen) {
      document.body.classList.remove('overflow-hidden')
      document.body.dispatchEvent(new CustomEvent('modalClosed'))

      if (CartDrawerNote) {
        if (CartDrawerNote.value.trim() !== '') {
          CartDrawerNoteAppla.classList.add('show')
        } else {
          CartDrawerNoteAppla.classList.remove('show')
        }
      }
    }

    const images = document.querySelector('.product-media-modal__content')

    if (images) {
      images.classList.remove('zoom')
    }

    setTimeout(() => this.classList.remove('hiding'), 700)
  }
}

customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()

    const button = this.querySelector('button')

    if (!button) return
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'))
      if (modal) modal.show(button)
    })

    if (this.closest('.product-popup') != null) {
      this.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'))
        if (modal) modal.show(button)
      })
    }
  }
}

customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this))
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

      this.setAttribute('loaded', true)
      window.pauseAllMedia()
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus()

      if (
        this.closest('.swiper')?.swiper.slides[this.closest('.swiper').swiper.activeIndex].querySelector('model-viewer')
      ) {
        if (
          !this.closest('.swiper')
            .swiper.slides[this.closest('.swiper').swiper.activeIndex].querySelector('model-viewer')
            .classList.contains('shopify-model-viewer-ui__disabled')
        ) {
          this.closest('.swiper').swiper.params.noSwiping = true
          this.closest('.swiper').swiper.params.noSwipingClass = 'swiper-slide'
        }
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia)

class VariantSelects extends HTMLElement {
  constructor() {
    super()
    this.storageKey = 'selected_options'
    this.storage = localStorage.getItem(this.storageKey)
    this.onLoadSelectedOptions()
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()

    // Don't temporarily disable button in quick-add modal (causes grey flash)
    const isQuickAddModal = this.closest('quick-add-modal')
    if (!isQuickAddModal) {
      this.toggleAddButton(true, '', false)
    }

    this.updatePickupAvailability()
    this.updateVariantStatuses()
    this.addSelectedOptionsToStorage(this.options)

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      if (!this.closest('floated-form')) {
        this.updateMedia()
      }
      this.updateURL()
      this.updateVariantInput()
      this.updateStockMessage()

      // Update button state based on variant availability
      if (isQuickAddModal) {
        this.toggleAddButton(
          !this.currentVariant.available,
          this.currentVariant.available ? '' : window.variantStrings.soldOut
        )
      } else {
        this.renderProductInfo()
      }
    }
  }

  onLoadSelectedOptions() {
    this.selectedOptions = this.getSelectedOptionsFromStorage()
    if (this.selectedOptions.length > 0) {
      this.options = this.selectedOptions
      this.setSelectedOption()
      this.updateMasterId()

      if (this.currentVariant === undefined) {
        return false
      }

      this.toggleAddButton(true, '', false)

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true)
        this.setUnavailable()
      } else {
        this.updateMedia()
        this.updateURL()
        this.updateVariantInput()
        this.renderProductInfo()
      }
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.js-radio-colors'))

    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value).concat(
      fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
      })
    )
  }

  setSelectedOption() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    fieldsets.forEach((fieldset, index) => {
      if (Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.value == this.options[index])) {
        Array.from(fieldset.querySelectorAll('input'))
          .find((radio) => radio.value == this.options[index])
          .setAttribute('checked', true)
        this.addSelectedOptionsToStorage(this.options)
      } else {
        Array.from(fieldset.querySelectorAll('input'))[0].setAttribute('checked', true)
        this.options[index] = Array.from(fieldset.querySelectorAll('input'))[0].value
      }
    })
  }

  updateMasterId() {
    if (this.variantData || this.querySelector('[type="application/json"]')) {
      const variantData = this.getVariantData()

      this.currentVariant = variantData.find((variant) => {
        const optionsCopy = [...this.options]
        const variantOptionsCopy = [...variant.options]
        optionsCopy.sort()
        variantOptionsCopy.sort()

        const matches = !variantOptionsCopy
          .map((option, index) => {
            // CASE-INSENSITIVE comparison for variant matching
            return optionsCopy[index]?.toString().toLowerCase() === option?.toString().toLowerCase()
          })
          .includes(false)

        if (matches) {
        }

        return matches
      })

      if (!this.currentVariant) {
      }
    }
  }

  isHidden(elem) {
    const styles = window.getComputedStyle(elem)
    return styles.display === 'none' || styles.visibility === 'hidden'
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return

    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    )

    const parent = newMedia.parentElement

    const swiperWrappers = document.querySelectorAll('.product__media-wrapper')

    swiperWrappers.forEach((elem) => {
      if (!this.isHidden(elem)) {
        const newMedia = elem.querySelector(
          `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        )

        if (elem.querySelector('.js-media-list')) {
          elem
            .querySelector('.js-media-list')
            .swiper.slideTo(elem.querySelector('.js-media-list').swiper.slides.indexOf(newMedia))
        } else {
          newMedia && parent.prepend(newMedia)

          window.setTimeout(() => {
            parent.scroll(0, 0)
          })
        }
      }
    })
  }

  updateURL() {
    if (!this.classList.contains('featured-product-radios')) {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
    }
  }

  updateVariantInput() {
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section

    // Try to find forms by ID first
    const productFormsById = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${sectionId}, #product-form-installment-${sectionId}`
    )

    // Also find all add-to-cart forms as a fallback
    const allProductForms = document.querySelectorAll('form[data-type="add-to-cart-form"]')

    // Combine both sets of forms
    const productForms = new Set([...productFormsById, ...allProductForms])

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      if (input) {
        input.value = this.currentVariant.id
        input.dispatchEvent(new Event('change', { bubbles: true }))
      }
    })
  }

  updateVariantStatuses() {
    // Get the first option group's checked value specifically, not just any checked input
    const firstOptionGroup = this.querySelector('.product-form__controls')
    const firstOptionValue = firstOptionGroup ? firstOptionGroup.querySelector(':checked')?.value : null

    // CASE-INSENSITIVE filtering for option1 variants
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => firstOptionValue?.toLowerCase() === variant.option1?.toLowerCase()
    )
    const inputWrappers = [...this.querySelectorAll('.product-form__controls')]
    inputWrappers.forEach((option, index) => {
      if (index === 0) return
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            // CASE-INSENSITIVE comparison for option matching
            variant[`option${index}`]?.toLowerCase() === previousOptionSelected?.toLowerCase()
        )
        .map((variantOption) => variantOption[`option${index + 1}`])
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    })
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        if (input.tagName === 'OPTION') {
          input.innerText = input.getAttribute('value')
        } else if (input.tagName === 'INPUT') {
          input.classList.remove('disabled')
        }
      } else {
        if (input.tagName === 'OPTION') {
          input.innerText = window.variantStrings.unavailable_with_option.replace(
            '[value]',
            input.getAttribute('value')
          )
        } else if (input.tagName === 'INPUT') {
          input.classList.add('disabled')
        }
      }
    })
  }

  updatePickupAvailability() {
    // Find pickup-availability within the same container/section to avoid affecting unrelated elements
    const sectionId = this.dataset.section
    const productInfo = document.getElementById(`ProductInfo-${sectionId}`)
    const pickUpAvailability = productInfo ? productInfo.querySelector('pickup-availability') : null

    if (!pickUpAvailability) return

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`)
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        )
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        )
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`)
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        )
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`)
        const colorNameSource = html.getElementById(
          `ColorName-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        )
        const colorNameDestination = document.getElementById(`ColorName-${this.dataset.section}`)

        if (source && destination) destination.innerHTML = source.innerHTML
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'))
        }
        if (colorNameSource && colorNameDestination) colorNameDestination.innerHTML = colorNameSource.innerHTML

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) price.classList.remove('visibility-hidden')

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '')

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const quickAddModal = this.closest('quick-add-modal')

    // In quick-add modal, find ALL add-to-cart buttons
    let addButtons = []
    let addButtonTexts = []

    if (quickAddModal) {
      const allForms = quickAddModal.querySelectorAll('form[data-type="add-to-cart-form"]')
      allForms.forEach((form) => {
        const btn = form.querySelector('[name="add"]')
        const btnText = form.querySelector('[name="add"] > span')
        if (btn) {
          addButtons.push(btn)
          if (btnText) addButtonTexts.push(btnText)
        }
      })
    } else {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`)
      if (!productForm) return
      const addButton = productForm.querySelector('[name="add"]')
      const addButtonText = productForm.querySelector('[name="add"] > span')
      if (addButton) {
        addButtons.push(addButton)
        if (addButtonText) addButtonTexts.push(addButtonText)
      }
    }

    if (addButtons.length === 0) {
      return
    }

    addButtons.forEach((addButton, index) => {
      if (disable) {
        // console.log(`[toggleAddButton] DISABLING button ${index}:`, addButton);
        addButton.setAttribute('disabled', 'disabled')
      } else {
        // console.log(`[toggleAddButton] ENABLING button ${index}:`, addButton);
        addButton.removeAttribute('disabled')
        // console.log(`[toggleAddButton] Button ${index} after enable - disabled attr:`, addButton.hasAttribute('disabled'), 'disabled prop:', addButton.disabled);
      }
    })

    addButtonTexts.forEach((addButtonText) => {
      if (disable && text) {
        addButtonText.textContent = text
      } else if (!disable) {
        addButtonText.textContent = window.variantStrings.addToCart
      }
    })

    if (!modifyClass) return
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`)
    const addButton = button.querySelector('[name="add"]')
    const price = document.getElementById(`price-${this.dataset.section}`)
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`)
    const sku = document.getElementById(`Sku-${this.dataset.section}`)

    if (!addButton) return
    this.toggleAddButton(true, window.variantStrings.unavailable)
    if (price) price.classList.add('visibility-hidden')
    if (inventory) inventory.classList.add('visibility-hidden')
    if (sku) sku.classList.add('visibility-hidden')
  }

  updateStockMessage() {
    if (!this.currentVariant) return
    const stockEl = this.querySelector('.product-form__stock-status')
    if (!stockEl) return
    if (this.currentVariant.available) {
      stockEl.textContent = 'In Stock'
    } else {
      stockEl.textContent = 'Sold Out'
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }

  getSelectedOptionsFromStorage() {
    let selectedOptions = []
    if (typeof this.storage == 'string') {
      selectedOptions = JSON.parse(this.storage)
    }
    return selectedOptions
  }

  addSelectedOptionsToStorage(newItem) {
    const stringifiedObj = JSON.stringify(newItem)
    if (stringifiedObj == '[object HTMLDivElement]' || stringifiedObj == null) return
    localStorage.setItem(this.storageKey, JSON.stringify(newItem))
  }
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled')
      } else {
        input.classList.add('disabled')
      }
    })
  }

  updateOptions() {
    const quickAddModal = this.closest('quick-add-modal')
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))

    // CRITICAL FIX: In quick-add modal with product-swatches, completely skip fieldsets and build options from scratch
    if (quickAddModal) {
      const productSwatches = quickAddModal.querySelector('product-swatches')

      if (productSwatches) {
        const selectedColorSwatch = productSwatches.querySelector('[data-row-colour] a.selected')

        if (selectedColorSwatch) {
          const variantData = this.getVariantData() || []
          const allColorValues = new Set(
            variantData.map((variant) => (variant.option1 || '').toString().trim().toLowerCase())
          )

          const colourFieldset = fieldsets.find((fieldset) => {
            const radio = fieldset.querySelector('input[type="radio"]')
            if (!radio) return false
            const name = radio.getAttribute('name') || ''
            return /color|colour/i.test(name)
          })

          // Get color - first try checked radio, then try to match from variant data
          let selectedColourValue = ''
          if (colourFieldset) {
            const checkedRadio = colourFieldset.querySelector('input[type="radio"]:checked')
            if (checkedRadio && checkedRadio.value) {
              selectedColourValue = checkedRadio.value
            } else {
              const allRadios = colourFieldset.querySelectorAll('input[type="radio"]')
            }
          }

          // If still no color, use first variant's option1
          if (!selectedColourValue && variantData.length > 0) {
            selectedColourValue = variantData[0].option1
          }

          if (colourFieldset) {
            const colourRadios = Array.from(colourFieldset.querySelectorAll('input[type="radio"]'))
            const matchingRadio = colourRadios.find((radio) => {
              const value = (radio.value || '').toString().trim().toLowerCase()
              return selectedColourValue && selectedColourValue.toString().trim().toLowerCase() === value
            })

            const markRadioChecked = (radio, forceDispatch = false) => {
              if (!radio) return
              if (!selectedColourValue) {
                selectedColourValue = radio.value
              }
              let shouldDispatch = forceDispatch
              if (!radio.checked) {
                radio.checked = true
                shouldDispatch = true
              }
              // Ensure downstream logic reacts to the updated colour selection
              if (shouldDispatch) {
                setTimeout(() => {
                  radio.dispatchEvent(new Event('change', { bubbles: true }))
                }, 0)
              }
            }

            if (matchingRadio) {
              selectedColourValue = matchingRadio.value
              markRadioChecked(matchingRadio)
            } else if (colourRadios.length) {
              const fallbackRadio = colourRadios[0]
              let dispatchNeeded = false
              if (selectedColourValue) {
                if (fallbackRadio.value !== selectedColourValue) {
                  fallbackRadio.value = selectedColourValue
                  dispatchNeeded = true
                }
                const fallbackLabel = colourFieldset.querySelector(`label[for="${fallbackRadio.id}"]`)
                if (fallbackLabel) {
                  fallbackLabel.setAttribute('value', selectedColourValue)
                  if (fallbackLabel.tagName === 'LABEL') {
                    const hiddenSpan = fallbackLabel.querySelector('.visually-hidden')
                    if (hiddenSpan) {
                      hiddenSpan.textContent = selectedColourValue
                    } else if (!fallbackLabel.classList.contains('color-swatch')) {
                      fallbackLabel.textContent = selectedColourValue
                    }
                  }
                }
              }
              markRadioChecked(fallbackRadio, dispatchNeeded || !fallbackRadio.checked)
            }
          }

          if (!selectedColourValue && variantData.length > 0) {
            selectedColourValue = variantData[0].option1
          }

          // Normalise the colour for comparisons but keep the original casing for this.options
          const normalisedSelectedColour = selectedColourValue
            ? selectedColourValue.toString().trim().toLowerCase()
            : ''

          this.options = []

          if (selectedColourValue) {
            this.options.push(selectedColourValue)
          }

          // Collect the rest of the checked option values, skipping colour entries
          fieldsets.forEach((fieldset) => {
            if (fieldset === colourFieldset) return

            const checkedInput = fieldset.querySelector('input[type="radio"]:checked')
            if (!checkedInput) return

            const value = checkedInput.value
            if (!value) return

            const normalisedValue = value.toString().trim().toLowerCase()

            if (normalisedValue && allColorValues.has(normalisedValue)) {
              return
            }

            if (!this.options.includes(value)) {
              this.options.push(value)
            }
          })

          return
        } else {
        }
      } else {
      }
    }

    // Original logic for non-modal or when product-swatches doesn't exist
    this.options = fieldsets
      .map((fieldset) => {
        const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)
        // If no radio is checked, default to the first radio's value
        if (!checkedRadio) {
          const firstRadio = fieldset.querySelector('input[type="radio"]')
          if (firstRadio) {
            firstRadio.checked = true
            return firstRadio.value
          }
          return null
        }
        return checkedRadio.value
      })
      .filter(Boolean)
  }

  setSelectedOption() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    fieldsets.forEach((fieldset, index) => {
      if (Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.value == this.options[index])) {
        Array.from(fieldset.querySelectorAll('input'))
          .find((radio) => radio.value == this.options[index])
          .setAttribute('checked', true)
        this.addSelectedOptionsToStorage(this.options)
      } else {
        Array.from(fieldset.querySelectorAll('input'))[0].setAttribute('checked', true)
        this.options[index] = Array.from(fieldset.querySelectorAll('input'))[0].value
      }
    })
  }
}

customElements.define('variant-radios', VariantRadios)

class PasswordViewer {
  constructor() {
    const passwordField = document.querySelectorAll('.field--pass')

    passwordField.forEach((el) => {
      const input = el.querySelector('input')
      const btnWrapper = el.querySelector('.button-pass-visibility')
      const btnOpen =
        el.querySelector('.icon-eye-close') !== null
          ? el.querySelector('.icon-eye-close')
          : el.querySelector('.pass-hide')
      const btnClose =
        el.querySelector('.icon-eye') !== null ? el.querySelector('.icon-eye') : el.querySelector('.pass-show')

      input.addEventListener('input', () => {
        input.value !== '' ? (btnWrapper.style.display = 'block') : (btnWrapper.style.display = 'none')
      })

      btnOpen.addEventListener('click', () => {
        input.type = 'text'
        btnOpen.style.display = 'none'
        btnClose.style.display = 'block'
      })

      btnClose.addEventListener('click', () => {
        input.type = 'password'
        btnOpen.style.display = 'block'
        btnClose.style.display = 'none'
      })
    })
  }
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super()

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('product-recommendations')
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }

          /* Color swatches */
          const generateSrcset = (image, widths = []) => {
            const imageUrl = new URL(image['src'])
            return widths
              .filter((width) => width <= image['width'])
              .map((width) => {
                imageUrl.searchParams.set('width', width.toString())
                return `${imageUrl.href} ${width}w`
              })
              .join(', ')
          }

          const createImageElement = (image, classes, sizes, productTitle) => {
            const previewImage = image['preview_image']
            const newImage = new Image(previewImage['width'], previewImage['height'])
            newImage.className = classes
            newImage.alt = image['alt'] || productTitle
            newImage.sizes = sizes
            newImage.src = previewImage['src']
            newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066])
            newImage.loading = 'lazy'
            return newImage
          }

          const checkSwatches = () => {
            document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
              wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
                input.addEventListener('click', (event) => {
                  const primaryImage = wrapper.querySelector('.media--first')
                  const secondaryImage = wrapper.querySelector('.media--second')
                  const handleProduct = wrapper.dataset.product

                  if (event.currentTarget.checked && primaryImage) {
                    wrapper
                      .querySelector('.js-color-swatches-link')
                      .setAttribute('href', event.currentTarget.dataset.variantLink)
                    if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
                      wrapper
                        .querySelector('.card__add-to-cart button[name="add"]')
                        .setAttribute('aria-disabled', false)
                      if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
                        wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden')
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
                          .classList.add('hidden')
                      }
                      wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
                        event.currentTarget.dataset.variantId
                    }
                    const currentColor = event.currentTarget.value

                    jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
                      const variant = product.variants.filter(
                        (item) => item.featured_media != null && item.options.includes(currentColor)
                      )[0]

                      if (variant) {
                        const newPrimaryImage = createImageElement(
                          variant['featured_media'],
                          primaryImage.className,
                          primaryImage.sizes,
                          product.title
                        )

                        if (newPrimaryImage.src !== primaryImage.src) {
                          let flag = false
                          if (secondaryImage) {
                            const secondaryImagePathname = new URL(secondaryImage.src).pathname
                            const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname

                            if (secondaryImagePathname == newPrimaryImagePathname) {
                              primaryImage.remove()
                              secondaryImage.classList.remove('media--second')
                              secondaryImage.classList.add('media--first')
                              flag = true
                            }
                          }
                          if (flag == false) {
                            primaryImage.animate(
                              { opacity: [1, 0] },
                              {
                                duration: 200,
                                easing: 'ease-in',
                                fill: 'forwards'
                              }
                            ).finished
                            setTimeout(function () {
                              primaryImage.replaceWith(newPrimaryImage)
                              newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: 'ease-in' })
                              if (secondaryImage) {
                                secondaryImage.remove()
                              }
                            }, 200)
                          }
                        }
                      }
                    })
                  }
                })
              })
            })
          }

          checkSwatches()

          const calcTop = (section) => {
            const imageWrapper = section.querySelectorAll('.card__inner')
            let top = 0

            if (imageWrapper) {
              top = imageWrapper[0]?.offsetHeight / 2
            } else {
              top = 50
            }

            return top
          }

          const initSlider = () => {
            document.querySelectorAll('.js-recommendation-swiper').forEach((elem, index) => {
              let mobileLayout = 1
              if (elem.dataset.mobileLayout) {
                mobileLayout = elem.dataset.mobileLayout
              }
              let slider = new Swiper(elem, {
                slidesPerView: mobileLayout,
                spaceBetween: 8,
                speed: 600,
                navigation: {
                  nextEl: elem.querySelector('.product-recommendations__slider-nav .swiper-button-next'),
                  prevEl: elem.querySelector('.product-recommendations__slider-nav .swiper-button-prev')
                },
                breakpoints: {
                  576: {
                    slidesPerView: 2
                  }
                }
              })
            })
          }

          const initSection = () => {
            const section = this

            const sectionResizeObserver = new ResizeObserver((entries) => {
              const [entry] = entries
              let top = calcTop(section)
              if (section.querySelector('.product-recommendations__slider-nav'))
                section.querySelector('.product-recommendations__slider-nav').style.top = top + 'px'
            })

            sectionResizeObserver.observe(section)

            initSlider()
          }

          const initProductSlider = () => {
            const sliders = document.querySelectorAll('.product-card-js')

            sliders.forEach((slider, index) => {
              const productSlider = new Swiper(slider, {
                pagination: {
                  el: '.product-pagination .swiper-pagination'
                },
                navigation: {
                  enabled: false,
                  nextEl: '.product-button-group .swiper-button-next',
                  prevEl: '.product-button-group .swiper-button-prev'
                },
                scrollbar: {
                  el: '.swiper-scrollbar',
                  draggable: true
                }
              })
            })
          }

          initProductSlider()

          initSection()
        })
        .catch((e) => {
          console.error(e)
        })
    }

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px'
    }).observe(this)
  }
}

customElements.define('product-recommendations', ProductRecommendations)
;(function () {
  const initHeaderOverlay = () => {
    const main = document.getElementById('MainContent')
    const sections = main.querySelectorAll('.shopify-section')
    if (sections.length > 0) {
      const sectionFirstChild = sections[0].querySelector('.section--has-overlay')
      const headerGroupSections = document.querySelectorAll('.shopify-section-group-header-group')
      const header = document.querySelector('.shopify-section-header')

      if (sectionFirstChild) {
        if (sectionFirstChild.classList.contains('section--has-overlay')) {
          if (headerGroupSections[headerGroupSections.length - 1] === header) {
            sections[0].classList.remove('not-margin')
            header.classList.add('color-background-1', 'color-background-2')
          } else {
            sections[0].classList.add('not-margin')
            header.classList.remove('color-background-1', 'color-background-2')
          }
        } else {
          sections[0].classList.remove('not-margin')
          header.classList.remove('color-background-1', 'color-background-2')
        }
      }
    }
  }

  initHeaderOverlay()

  document.addEventListener('shopify:section:load', function () {
    initHeaderOverlay()
  })

  document.addEventListener('shopify:section:unload', function () {
    initHeaderOverlay()
  })

  document.addEventListener('shopify:section:reorder', function () {
    initHeaderOverlay()
  })
})()

function formatMoney(cents, format = '') {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '')
  }

  cents = parseInt(cents, 10)
  let value = ''
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  const formatString = format || theme.moneyFormat

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) {
      return '0'
    }

    number = (number / 100.0).toFixed(precision)

    const parts = number.split('.')
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`)
    const centsAmount = precision > 0 ? decimal + parts[1] : ''

    return dollarsAmount + centsAmount
  }

  const match = formatString.match(placeholderRegex)
  const formatType = match ? match[1] : 'amount'

  switch (formatType) {
    case 'amount':
      value = formatWithDelimiters(cents, 2, ',', '.')
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0, ',', '.')
      break
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.')
      break
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ', '.')
      break
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',')
      break
    case 'amount_with_period_and_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.')
      break
    default:
      value = formatWithDelimiters(cents, 2, ',', '.')
  }

  return formatString.replace(placeholderRegex, value)
}

class LocalizationForm extends HTMLElement {
  constructor() {
    super()
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('.disclosure__button-modal'),
      panel: this.querySelector('ul'),
      buttonSave: this.querySelector('.button-save'),
      buttonSpan: this.querySelector('.disclosure__button-modal span')
    }

    // Example usage:
    const targetElement = this.elements.button
    const excludeElement = this.elements.panel

    this.elements.button?.addEventListener('click', this.openSelector.bind(this))
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this))

    this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)))

    this.elements.buttonSave?.addEventListener('click', this.onClickSave.bind(this))

    this.handleClickOutside(targetElement, excludeElement)
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false')
    this.elements.panel.setAttribute('hidden', true)
  }

  handleClickOutside(target, exclude) {
    document.addEventListener('click', (event) => {
      if (!target.contains(event.target) && (!exclude || !exclude.contains(event.target))) {
        this.hidePanel()
      }
    })
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    this.hidePanel()
    this.elements.button.focus()
  }

  onItemClick(event) {
    event.preventDefault()
    this.elements.input.value = event.currentTarget.dataset.value
    if (document.querySelectorAll('.region_language_dropdown_type').length > 0) {
      this.querySelector('form')?.submit()
    } else {
      let itemValue = event.currentTarget.dataset.valuesave
      this.elements.buttonSpan.textContent = event.currentTarget.textContent
      this.elements.button.setAttribute('data-value', itemValue)
      this.hidePanel()
    }
  }

  onClickSave() {
    this.querySelector('form')?.submit()
  }

  openSelector() {
    this.elements.button.focus()
    this.elements.panel.toggleAttribute('hidden')
    this.elements.button.setAttribute(
      'aria-expanded',
      (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
    )
    document.body.classList.add('region-open')
  }

  closeSelector(event) {
    if (!this.contains(event.relatedTarget)) {
      this.hidePanel()
    }
  }
}

customElements.define('localization-form', LocalizationForm)
;(function () {
  const imagesnumber = () => {
    $(document).scroll(scrolled)
    $(document).ready(scrolled)

    const scroll_line = 32

    function scrolled() {
      const images = $('.img-responsive')
      for (var i = 2; i < images.length; i++) {
        let pos = images.eq(i).offset().top - $(document).scrollTop()
        if (pos > scroll_line) {
          break
        }
      }
      let current_image = i

      $('#image_number .first_number').html(current_image > 10 ? current_image : '0' + current_image)
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    imagesnumber()
    document.addEventListener('shopify:section:load', function () {
      imagesnumber()
    })
  })
})()
;(function () {
  const selectDropDown = () => {
    $('.product-form__controls--dropdown').each(function () {
      const elListItem = $(this).find('.dropdown-select ul li')
      const elItem = $(this).find('.dropdown-select ul')
      const selectedText = $(this).find('.dropdown-select .select-label')

      selectedText.on('click', function (e) {
        elItem.toggleClass('active')
        if (elItem.hasClass('active')) {
          e.stopPropagation()
          $(document).click(function () {
            elItem.removeClass('active')
          })
        }
      })

      elListItem.on('click', function () {
        if ($(this).find('input').hasClass('disabled') == false) {
          selectedText.find('span').text($(this).text()).attr('title', $(this).text())
        }

        elItem.removeClass('active')
        document.activeElement.blur()
      })
    })
  }
  document.addEventListener('DOMContentLoaded', function () {
    selectDropDown()
    document.addEventListener('shopify:section:load', function () {
      selectDropDown()
    })
  })
})()

class ProductSwatches extends HTMLElement {
  constructor() {
    super()

    this.container = this.querySelector('.product-swatches__container')
    this.availableColorsContainer = this.querySelector('.product-grid-item__siblings-available')
    this.isProductPageSwatch = this.closest('[id^="MainProduct"] .product__info-container') || false
    const productParameters = this.closest('.product-parameters')
    this.cardColorCountValue = productParameters
      ? productParameters.querySelector('[data-product-color-count-value]')
      : null
    this.cardColorCountWrapper = this.cardColorCountValue
      ? this.cardColorCountValue.closest('[data-product-color-count]')
      : null

    this.settings = this.setSettings()
    var hideIfEmpty = this.settings.hideIfEmpty

    if (this.settings.groupTag) {
      const groupTAG = encodeURIComponent(this.settings.groupTag).replace('.', '-')
      this.fetchData(groupTAG)
        .then((responseJson) => {
          this.initSwatches(responseJson)
          this.setCurrent(this.settings.handle)
          this.hideIfEmpty(hideIfEmpty)
          // Bind events for product cards OR quick-add modals, but not regular product pages
          if (!this.isProductPageSwatch) {
            this.bindEvents()
          }
        })
        .catch((err) => {
          console.error(err)
        })
    } else {
      this.hideIfEmpty(hideIfEmpty)
      this.initSwatches([])
    }
  }

  fetchData(groupTAG) {
    const sessionSwatchJson = sessionStorage.getItem(groupTAG)

    if (sessionSwatchJson != null) {
      // console.log("%cFetched from session", "color:green");
      return new Promise((resolve) => {
        resolve(JSON.parse(sessionSwatchJson))
      })
    }

    // console.log("%cFetched from URL", "color:green");
    return this.getDataFromShopifyUrl(groupTAG)
  }

  getDataFromShopifyUrl(groupTAG) {
    return new Promise((resolve, reject) => {
      fetch(`/collections/all/${groupTAG}?view=data`)
        .then((response) => {
          if (response.ok == false) {
            return []
          }
          return response.json()
        })
        .then((responseJson) => {
          sessionStorage.setItem(groupTAG, JSON.stringify(responseJson))

          resolve(responseJson)
        })
        .catch((err) => {
          console.error(err)
          reject(err)
        })
    })
  }

  bindEvents() {
    const parent = this.closest('[data-card-wrapper]')
    const swatches = this.querySelectorAll('[data-row-colour] a')
    const isQuickAdd = this.dataset.quickAdd == 'true'
    // Check if we're inside a quick-add modal
    const isInsideQuickAddModal = this.closest('quick-add-modal') !== null
    // Check if we're inside a bundle drawer
    const isInsideBundleDrawer = this.closest('[data-bundle-drawer]') !== null

    if (!swatches) return

    var self = this

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', function (e) {
        e.preventDefault()

        // If we're in a quick add modal, just update the images and form
        if (isInsideQuickAddModal) {
          const productHandle = swatch.dataset.handle
          const quickAddModal = self.closest('quick-add-modal')

          if (!quickAddModal) return

          // Fetch product data (lighter than full HTML)
          fetch(`/products/${productHandle}.js`)
            .then((response) => response.json())
            .then((product) => {
              // Find the media slider
              const mediaList = quickAddModal.querySelector('.js-media-list')
              if (!mediaList || !mediaList.swiper) return

              const swiper = mediaList.swiper
              const swiperWrapper = mediaList.querySelector('.swiper-wrapper')

              if (!swiperWrapper) return

              // Build new slides from product media
              let newSlidesHtml = ''
              product.media.forEach((media, index) => {
                const mediaId = media.id
                newSlidesHtml += `
                                    <div class="product__media-item swiper-slide product__media-item--contain"
                                         data-media-id="quickadd-template--20702115987691__main-${mediaId}">
                                        <modal-opener class="product__modal-opener product__modal-opener--image no-js-hidden"
                                                      data-modal="#ProductModal-quickadd-template--20702115987691__main">
                                            <span class="product__media-icon motion-reduce" aria-hidden="true">
                                                <svg class="icon icon-plus-zoom" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M15.9996 1.60001L15.9996 30.4M30.3996 16L1.59961 16" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                                                </svg>
                                            </span>
                                            <div class="product__media">
                                                <img src="${media.src}"
                                                     alt="${media.alt || product.title}"
                                                     loading="lazy"
                                                     class="img-responsive">
                                            </div>
                                            <button class="product__media-toggle focus-inset" type="button"
                                                    aria-haspopup="dialog" data-media-id="${mediaId}">
                                                <span class="visually-hidden">Open media ${index + 1} in gallery view</span>
                                            </button>
                                        </modal-opener>
                                    </div>
                                `
              })

              // Update slides
              swiperWrapper.innerHTML = newSlidesHtml

              // Update swiper and go to first slide
              swiper.update()
              swiper.slideTo(0, 300)

              // Update active swatch styling
              quickAddModal.querySelectorAll('[data-row-colour] a').forEach((s) => s.classList.remove('selected'))
              swatch.classList.add('selected')

              // Update the color name display
              const colorOption = quickAddModal.querySelector('[data-colour-option]')
              if (colorOption && product.options) {
                const colorValue = product.options.find(
                  (opt) =>
                    opt.name === 'color' || opt.name === 'Color' || opt.name === 'colour' || opt.name === 'Colour'
                )
                if (colorValue && colorValue.values && colorValue.values.length > 0) {
                  colorOption.textContent = colorValue.values[0]
                }
              }

              // CRITICAL FIX: Update ALL variant selector elements with new product data
              let selectedSize = null

              // Get currently selected size BEFORE updating variant data
              const productCardVariants = quickAddModal.querySelector('product-card-variants')
              if (productCardVariants) {
                const checkedSizeInput = productCardVariants.querySelector('input[type="radio"]:checked')
                if (checkedSizeInput) {
                  selectedSize = checkedSizeInput.value
                }

                // Update the variant data in product-card-variants to the NEW product
                const variantDataElement = productCardVariants.querySelector('[data-variants]')
                if (variantDataElement) {
                  variantDataElement.textContent = JSON.stringify(product.variants)
                  productCardVariants.variantData = product.variants
                  if (typeof productCardVariants.refreshOptionStates === 'function') {
                    productCardVariants.refreshOptionStates()
                  }
                }
              }

              // Update ALL variant-radios and variant-selects elements
              const variantElements = quickAddModal.querySelectorAll('variant-radios, variant-selects')
              variantElements.forEach((variantElement) => {
                const variantDataScript = variantElement.querySelector('[type="application/json"]')
                if (variantDataScript) {
                  variantDataScript.textContent = JSON.stringify(product.variants)
                  // Force immediate refresh by setting variantData directly
                  variantElement.variantData = product.variants
                }

                // CRITICAL FIX: Update the color radio button to match the selected swatch
                if (product.options && product.options.length > 0) {
                  const firstOption = product.options[0]
                  if (firstOption.values && firstOption.values.length > 0) {
                    const colorValue = firstOption.values[0]

                    // Find the color fieldset
                    const fieldsets = Array.from(variantElement.querySelectorAll('fieldset'))
                    const colorFieldset = fieldsets.find((fieldset) => {
                      const radio = fieldset.querySelector('input[type="radio"]')
                      if (!radio) return false
                      const name = radio.getAttribute('name') || ''
                      return /color|colour/i.test(name)
                    })

                    if (colorFieldset) {
                      const colorRadios = Array.from(colorFieldset.querySelectorAll('input[type="radio"]'))
                      // Find matching radio - only check ONE and trigger change ONCE
                      let matchingRadio = colorRadios.find(
                        (radio) => radio.value.toLowerCase() === colorValue.toLowerCase()
                      )

                      // If no matching radio, update the first radio's value
                      if (!matchingRadio && colorRadios.length > 0) {
                        matchingRadio = colorRadios[0]
                        matchingRadio.value = colorValue
                        // Also update the label
                        const label = colorFieldset.querySelector(`label[for="${matchingRadio.id}"]`)
                        if (label) {
                          const hiddenSpan = label.querySelector('.visually-hidden')
                          if (hiddenSpan) {
                            hiddenSpan.textContent = colorValue
                          }
                        }
                      }

                      if (matchingRadio) {
                        if (!matchingRadio.checked) {
                          matchingRadio.checked = true
                          // Only dispatch ONE change event
                          matchingRadio.dispatchEvent(new Event('change', { bubbles: true }))
                        } else {
                        }
                      } else {
                      }
                    }
                  }
                }
              })

              const forms = quickAddModal.querySelectorAll('form')
              forms.forEach((form) => {
                const variantInput = form.querySelector('input[name="id"]')
                if (variantInput && product.variants && product.variants.length > 0) {
                  let targetVariant

                  // If we have a selected size, find variant matching the size
                  // Note: we don't check v.available here because the size might be valid
                  // but just out of stock - we want to show "Notify Me" in that case
                  if (selectedSize) {
                    targetVariant = product.variants.find((v) => {
                      return v.options && v.options.includes(selectedSize)
                    })
                    // If not found with exact size, try available variants with that size
                    if (!targetVariant) {
                      targetVariant = product.variants.find((v) => {
                        return v.available && v.options && v.options.includes(selectedSize)
                      })
                    }
                  }

                  // Fall back to first available variant if no size selected or no match found
                  if (!targetVariant) {
                    targetVariant = product.variants.find((v) => v.available) || product.variants[0]
                  }

                  variantInput.value = targetVariant.id
                }
              })
            })
            .catch((error) => {
              console.error('Error fetching product:', error)
            })
        } else if (isInsideBundleDrawer) {
          // If we're inside a bundle drawer, update the entire card and drawer content
          const productHandle = swatch.dataset.handle
          const bundleDrawer = self.closest('[data-bundle-drawer]')

          if (!bundleDrawer) {
            return
          }

          // Find card wrapper - handle both desktop (drawer inside card) and mobile (drawer moved to body)
          let cardWrapper = bundleDrawer.closest('.card-wrapper--bundle')

          // On mobile, drawer is moved to body, so use aria-controls to find the card
          if (!cardWrapper && bundleDrawer.id) {
            const cardButton = document.querySelector(`[aria-controls="${bundleDrawer.id}"]`)
            if (cardButton) {
              cardWrapper = cardButton.closest('.card-wrapper--bundle')
            }
          }

          // Also try using the stored original parent (set by BundleCardDrawer)
          if (!cardWrapper && bundleDrawer._originalParent) {
            cardWrapper =
              bundleDrawer._originalParent.closest('.card-wrapper--bundle') ||
              bundleDrawer._originalParent.querySelector('.card-wrapper--bundle') ||
              (bundleDrawer._originalParent.classList.contains('card-wrapper--bundle')
                ? bundleDrawer._originalParent
                : null)
          }

          if (!cardWrapper) {
            return
          }

          // Fetch the new product data
          fetch(`/products/${productHandle}.js`)
            .then((response) => response.json())
            .then((product) => {
              // Update active swatch styling
              bundleDrawer.querySelectorAll('[data-row-colour] a').forEach((s) => s.classList.remove('selected'))
              swatch.classList.add('selected')

              // Update the drawer title
              const drawerTitle = bundleDrawer.querySelector('.card-bundle__drawer-title')
              if (drawerTitle) {
                drawerTitle.textContent = product.title
              }

              // Update the swatches legend color display (visual only)
              const swatchColorDisplay = bundleDrawer.querySelector('product-swatches .option--value')
              if (swatchColorDisplay && product.variants && product.variants.length > 0) {
                const colorValue = product.variants[0].option1 || ''
                if (colorValue) {
                  swatchColorDisplay.textContent = colorValue
                    .toLowerCase()
                    .split(' ')
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')
                }
              }

              // Update the card image(s)
              // Try multiple selectors to handle both regular cards and featured carousel cards
              let cardMedia = cardWrapper.querySelector('.card__inner .media img')
              if (!cardMedia) {
                // Try carousel slide image
                cardMedia = cardWrapper.querySelector('.card-bundle__media-slide img')
              }
              if (!cardMedia) {
                // Fallback to any img in card__inner
                cardMedia = cardWrapper.querySelector('.card__inner img')
              }

              if (cardMedia && product.featured_image) {
                cardMedia.src = product.featured_image
                cardMedia.srcset = '' // Clear srcset to force use of src
                cardMedia.alt = product.title
              }

              // Also update all carousel images if present
              const carouselImages = cardWrapper.querySelectorAll('.card-bundle__media-carousel img')
              if (carouselImages.length > 0 && product.media && product.media.length > 0) {
                carouselImages.forEach((img, index) => {
                  if (product.media[index]) {
                    img.src = product.media[index].src
                    img.srcset = ''
                    img.alt = product.media[index].alt || product.title
                  }
                })
              }

              // Update the card button data attributes
              const cardButton = cardWrapper.querySelector('[data-bundle-card-button]')
              if (cardButton) {
                cardButton.dataset.productId = product.id
                cardButton.dataset.productTitle = product.title
                cardButton.dataset.productHandle = product.handle
                if (product.featured_image) {
                  cardButton.dataset.productImage = product.featured_image
                }
                // Clear variant selection since we're switching products
                delete cardButton.dataset.variantId
                delete cardButton.dataset.variantPrice
              }

              // Update the card-wrapper data attribute
              cardWrapper.dataset.product = product.handle

              // Update size options in bundle-variant-radios
              const bundleRadios = bundleDrawer.querySelector('bundle-variant-radios')
              if (bundleRadios) {
                // Update the product handle
                bundleRadios.dataset.productHandle = product.handle

                // Update the color display element for variant matching
                const colorDisplay = bundleRadios.querySelector('.product-options-color-display')
                if (colorDisplay && product.options && Array.isArray(product.options)) {
                  const colorOptionIndex = product.options.findIndex(
                    (opt) =>
                      typeof opt === 'string' && (opt.toLowerCase() === 'color' || opt.toLowerCase() === 'colour')
                  )
                  let newColorValue = null
                  if (colorOptionIndex !== -1 && product.variants && product.variants.length > 0) {
                    const firstVariant = product.variants[0]
                    newColorValue = firstVariant.options ? firstVariant.options[colorOptionIndex] : ''
                  } else if (product.variants && product.variants.length > 0 && product.variants[0].option1) {
                    newColorValue = product.variants[0].option1
                  }
                  if (newColorValue) {
                    colorDisplay.dataset.colorValue = newColorValue
                    colorDisplay.textContent = newColorValue
                      .toLowerCase()
                      .split(' ')
                      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' ')
                  }
                }

                // Find the size fieldset
                const sizeFieldset = Array.from(bundleRadios.querySelectorAll('fieldset')).find((fieldset) => {
                  const label = fieldset.querySelector('.product-options-label')
                  if (!label) return false
                  const labelText = label.textContent.toLowerCase().trim()
                  return labelText.includes('size')
                })

                if (sizeFieldset) {
                  const controlsGroup = sizeFieldset.querySelector('.product-form__controls-group')
                  if (controlsGroup && product.options && Array.isArray(product.options)) {
                    // Find the size option index from the new product
                    const sizeOptionIndex = product.options.findIndex(
                      (opt) => typeof opt === 'string' && opt.toLowerCase() === 'size'
                    )

                    if (sizeOptionIndex !== -1) {
                      // Get unique size values from variants
                      const sizeValues = [
                        ...new Set(
                          product.variants.map((v) => (v.options ? v.options[sizeOptionIndex] : null)).filter(Boolean)
                        )
                      ]

                      // Get available sizes (variants that are in stock)
                      const availableSizes = product.variants
                        .filter((v) => v.available)
                        .map((v) => (v.options ? v.options[sizeOptionIndex] : null))
                        .filter(Boolean)

                      // Generate unique IDs for this product
                      const sectionId = bundleRadios.id.replace('bundle-variant-radios-', '').split('-')[0]

                      // Build new size options HTML
                      let sizesHtml = ''
                      sizeValues.forEach((size, index) => {
                        const uniqueId = `bundle-${sectionId}-${product.id}-size-${index}`
                        const isDisabled = !availableSizes.includes(size)
                        const isChecked = index === 0 ? 'checked' : ''
                        const disabledClass = isDisabled ? 'disabled' : ''

                        sizesHtml += `
                          <input
                            dir="ltr"
                            type="radio"
                            id="${uniqueId}"
                            name="bundle-Size-${sectionId}-${product.id}"
                            value="${size}"
                            ${isChecked}
                            class="${disabledClass}">
                          <label
                            for="${uniqueId}"
                            class="focus-inset link-hover-line secondary_text product-size-option">
                            ${size}
                            <span class="visually-hidden">Variant sold out or unavailable</span>
                          </label>
                        `
                      })

                      controlsGroup.innerHTML = sizesHtml
                    }
                  }
                }

                // Update the variant JSON data
                const variantDataScript = bundleRadios.querySelector('[type="application/json"]')
                if (variantDataScript) {
                  variantDataScript.textContent = JSON.stringify(product.variants)
                  // Reset cached variant data using the refresh method
                  if (typeof bundleRadios.refreshVariantData === 'function') {
                    bundleRadios.refreshVariantData()
                  } else {
                    bundleRadios.variantData = null
                  }
                }

                // Update stock status display
                const stockStatus = bundleRadios.querySelector('.product-form__stock-status')
                if (stockStatus) {
                  const firstAvailableVariant = product.variants.find((v) => v.available)
                  if (firstAvailableVariant) {
                    stockStatus.innerHTML = `
                      <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.50713 9.40993L3.80002 10.117L4.55584 10.8728L5.25971 10.0684L4.50713 9.40993ZM12.2597 2.06843L12.9182 1.31585L11.4131 -0.00115657L10.7546 0.75142L11.5071 1.40992L12.2597 2.06843ZM4.50713 9.40993L5.25971 10.0684L12.2597 2.06843L11.5071 1.40992L10.7546 0.75142L3.75455 8.75142L4.50713 9.40993ZM4.50713 9.40993L5.21424 8.70282L1.41419 4.90277L0.707081 5.60988L-2.58188e-05 6.31698L3.80002 10.117L4.50713 9.40993Z" fill="#191515"/>
                      </svg>
                      In Stock
                    `
                  } else {
                    stockStatus.innerHTML = 'Sold Out'
                  }
                }

                // Reinitialize the bundle radios component
                bundleRadios.updateOptions()
                bundleRadios.updateMasterId()

                // Notify button of variant change
                if (bundleRadios.currentVariant) {
                  const event = new CustomEvent('bundle:variant-selected', {
                    bubbles: true,
                    detail: {
                      hasVariant: true,
                      variant: bundleRadios.currentVariant,
                      userTriggered: true
                    }
                  })
                  bundleRadios.dispatchEvent(event)
                } else {
                  // Even without variant, dispatch to reset button state
                  const event = new CustomEvent('bundle:variant-selected', {
                    bubbles: true,
                    detail: {
                      hasVariant: false,
                      variant: null,
                      userTriggered: true
                    }
                  })
                  bundleRadios.dispatchEvent(event)
                }
              }

              // Update price on the card button
              const priceElement = cardWrapper.querySelector('.card-bundle__button-price')
              if (priceElement && product.price) {
                priceElement.textContent = formatMoney(product.price, window.theme?.moneyFormat || '${{amount}}')
              }

              // Emit event for any listeners that need to know the product changed
              const productChangedEvent = new CustomEvent('bundle:product-changed', {
                bubbles: true,
                detail: {
                  product: product,
                  cardWrapper: cardWrapper
                }
              })
              cardWrapper.dispatchEvent(productChangedEvent)
            })
            .catch((error) => {
              console.error('Error fetching product for bundle drawer:', error)
            })
        } else if (isQuickAdd) {
          // If we're in a card quick add context
          const productHandle = swatch.dataset.handle

          // Fetch the product data to get the images
          fetch(`/products/${productHandle}.js`)
            .then((response) => response.json())
            .then((product) => {
              // Find the carousel wrapper
              const carouselSection = parent.querySelector('.card__media-carousel')
              if (!carouselSection) return

              const swiperWrapper = carouselSection.querySelector('.swiper-wrapper')
              if (!swiperWrapper) return

              // Get the existing swiper instance and destroy it
              const sliderContainer = carouselSection.querySelector('.js-slider-collectionPage')
              if (sliderContainer && sliderContainer.swiper) {
                sliderContainer.swiper.destroy(true, true)
              }

              // Build new slides HTML
              let slidesHtml = ''
              product.media.forEach((media, index) => {
                if (media.media_type === 'image') {
                  const imgUrl = media.src
                  slidesHtml += `
                                        <a class="media--hover-effect swiper-slide slider__slide"
                                           href="/products/${productHandle}"
                                           data-slide="${index}"
                                           role="group"
                                           aria-label="slide ${index + 1} of ${product.media.length}">
                                            <img src="${imgUrl}"
                                                 alt="${media.alt || product.title}"
                                                 class="motion-reduce"
                                                 loading="lazy">
                                        </a>
                                    `
                }
              })

              // Update the wrapper with new slides
              swiperWrapper.innerHTML = slidesHtml

              // Reinitialize the swiper
              new Swiper(sliderContainer, {
                slidesPerView: 1.7,
                spaceBetween: 8,
                loop: false,
                freeMode: {
                  enabled: true,
                  sticky: true,
                  momentumRatio: 0.3
                }
              })

              // Update active swatch
              parent.querySelectorAll('[data-row-colour] a').forEach((s) => s.classList.remove('selected'))
              swatch.classList.add('selected')
            })
            .catch((error) => {
              console.error('Error fetching product data:', error)
            })
        } else {
          // Original behavior for non-quick-add contexts
          fetchCardSlideData(swatch.dataset.handle, isQuickAdd).then((cardSlide) => {
            if (self.settings.showVendor === false) {
              const elementToRemove = cardSlide.querySelector('.card__information .caption-with-letter-spacing')
              if (elementToRemove) {
                elementToRemove.remove()
              }
              parent.classList.add('no-vendor')
            }

            parent.innerHTML = cardSlide.innerHTML

            const slider = parent.querySelector('.js-slider-collectionPage')
            let sliderConfig = {
              slidesPerView: 'auto',
              loop: false,
              freeMode: {
                enabled: true,
                sticky: true,
                momentumRatio: 0.3
              },
              grabCursor: true,
              pagination: {
                el: '.swiper-pagination'
              },
              navigation: {
                nextEl: '.js-card-slider-arrow-next',
                prevEl: '.js-card-slider-arrow-prev'
              }
            }

            new Swiper(slider, {
              ...sliderConfig
            })

            const swatchProdUrl = `/products/${swatch.dataset.handle}`

            if (swatch.dataset.handle) {
              parent.querySelector('.quick-add-btn').addEventListener('click', () => {
                fetch(swatchProdUrl + '?view=quick-add')
                  .then((res) => res.text())
                  .then((quickAddStr) => {
                    const $quickAddModal = document.querySelector('.quick-add-modal')
                    $quickAddModal.querySelector('.quick-add-modal__inner').innerHTML = quickAddStr
                    const $slider = $quickAddModal.querySelector('.js-slider-collectionPage')
                    new Swiper($slider, {
                      slidesPerView: 1.7,
                      spaceBetween: 8,
                      loop: false,
                      freeMode: {
                        enabled: true,
                        sticky: true,
                        momentumRatio: 0.3
                      }
                    })
                    $quickAddModal.classList.add('open')
                    document.body.classList.add('overflow-hidden')
                  })
              })
            }
          })
        }
      })
    })
  }

  hideIfEmpty(hideIfEmpty) {
    if (!hideIfEmpty) return
    const availableSwatches = this.querySelectorAll('.product-swatches__container [data-available="true"]')
    if (availableSwatches.length == 0) {
      this.classList.add('swatch-empty--hide')
    }
  }

  setSettings() {
    const settingsRawJson = this.querySelector('[data-swatches-settings]')
    if (!settingsRawJson) return {}
    return JSON.parse(settingsRawJson.innerHTML)
  }

  initSwatches(products, maxIndex = 99) {
    var html = ''
    var optionsObject = {}
    let colourCount = 0
    const colourValues = new Set()

    if (!this.settings.swatchOptions) return

    for (const option of this.settings.swatchOptions) {
      optionsObject[`${option}`] = [...new Set(products.map((p) => p[`${option}`]))].filter((n) => n)
    }
    const colourOptions = optionsObject['colour'] || []
    const uniqueColours = [...new Set(products.map((prod) => prod.colour))].filter(Boolean)
    colourCount = colourOptions.length || uniqueColours.length || products.length || colourCount

    let index = 0

    for (const option in optionsObject) {
      const optionLabel = this.formatLabel(option.replace(/_/g, ' '))
      const optionValueDisplay = this.formatLabel(this.settings[`${option}`] || '')
      html =
        html +
        `
        <legend class="form__label option--label">
          <span class="option-label-group">
            <span class="option-label-text">${optionLabel}</span>
            <span class="option--value" data-${option}-option>${optionValueDisplay}</span>
          </span>
        </legend>
        <div data-row-${option} class="product-swatches__container-row">`

      for (const optionValue of optionsObject[`${option}`]) {
        var potentialProducts = products.filter((p) => p[`${option}`] == optionValue)

        if (!potentialProducts.length) continue

        var product = potentialProducts[0]

        if (potentialProducts.length > 0) {
          for (const innerOption of this.settings.swatchOptions) {
            if (innerOption == option) continue
            potentialProducts = potentialProducts.filter((p) => p[`${innerOption}`] == this.settings[`${innerOption}`])
          }
          product = potentialProducts[0]
        }

        var firstAvailableVariant = null

        if (!product) continue

        for (const v of product.variants) {
          if (v.inventory_quantity > 0) {
            firstAvailableVariant = v
            break
          }
        }

        var img = this.getProductImage(product, option)

        if (option === 'colour' && optionValue) {
          colourValues.add(optionValue)
        }

        const el = `<div class="pils-wrapper">
          <a data-available="${firstAvailableVariant ? 'true' : 'false'}" data-handle="${product.handle}" href="/products/${product.handle}" title="${product.colour || ''}">
          ${img}
          <span class="color-name">${product.colour}</span>
          </a>
        </div>`

        if (index < maxIndex) {
          html += el
        }

        index += 1
      }

      const showMoreSwatchCounters = !this.isProductPageSwatch && !this.closest('[data-bundle-drawer]')
      const mobileMaxIdx = 3
      const desktopMaxIdx = 5

      if (showMoreSwatchCounters && index > mobileMaxIdx) {
        html += `<span class="mobile-more-swatches">+${index - 3}</span>`
      }

      if (showMoreSwatchCounters && index > desktopMaxIdx) {
        html += `<span class="desktop-more-swatches">+${index - 5}</span>`
      }

      html = html + '</div>'
    }

    if (colourValues.size && colourCount < colourValues.size) {
      colourCount = colourValues.size
    }

    if (html) {
      this.container.innerHTML = html
      this.container.hidden = false
      this.container.removeAttribute('hidden')

      // Add carousel navigation for bundle drawer swatches
      const isInsideBundleDrawer = this.closest('[data-bundle-drawer]') !== null
      if (isInsideBundleDrawer) {
        this.initSwatchCarouselNav()
      }

      const swatchElements = this.container.querySelectorAll('[data-row-colour] a')
      if (swatchElements.length) {
        const elementCount = swatchElements.length
        colourCount = Math.max(colourCount, elementCount)
      }

      const $mobileMoreSwatchesBtn = this.container.querySelector('.mobile-more-swatches')

      if ($mobileMoreSwatchesBtn && this.container.dataset.productUrl) {
        $mobileMoreSwatchesBtn.addEventListener('click', () => {
          fetch(this.container.dataset.productUrl + '?view=quick-add')
            .then((res) => res.text())
            .then((quickAddStr) => {
              const $quickAddModal = document.querySelector('.quick-add-modal')
              $quickAddModal.querySelector('.quick-add-modal__inner').innerHTML = quickAddStr
              const $slider = $quickAddModal.querySelector('.js-slider-collectionPage')
              new Swiper($slider, {
                slidesPerView: 1.7,
                spaceBetween: 8,
                loop: false,
                freeMode: {
                  enabled: true,
                  sticky: true,
                  momentumRatio: 0.3
                }
              })
              $quickAddModal.classList.add('open')
              document.body.classList.add('overflow-hidden')
            })
        })
      }
    }

    if (this.availableColorsContainer) {
      const totalColours = colourCount
      this.availableColorsContainer.innerHTML = `${totalColours} colour${totalColours > 1 ? 's' : ' '}`
    }
    if (this.cardColorCountValue) {
      const totalColours = colourCount
      if (totalColours > 0) {
        this.cardColorCountValue.textContent = totalColours
        if (this.cardColorCountWrapper) {
          this.cardColorCountWrapper.classList.remove('is-hidden')
        }
      } else if (this.cardColorCountWrapper) {
        this.cardColorCountWrapper.classList.add('is-hidden')
      }
    }
  }

  initSwatchCarouselNav() {
    // Find all swatch container rows and add navigation arrows
    const containerRows = this.container.querySelectorAll('.product-swatches__container-row')

    containerRows.forEach((row) => {
      const legend = row.previousElementSibling
      if (!legend || legend.tagName !== 'LEGEND') return

      // Check if navigation already exists
      if (legend.querySelector('.swatch-carousel-nav')) return

      // Create navigation arrows
      const navContainer = document.createElement('div')
      navContainer.className = 'swatch-carousel-nav'
      navContainer.innerHTML = `
        <button type="button" class="swatch-carousel-arrow swatch-carousel-arrow--prev" aria-label="Previous" disabled>
          <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.5 5.5L14.5 16.5L7.5 11L14.5 5.5Z"/>
          </svg>
        </button>
        <button type="button" class="swatch-carousel-arrow swatch-carousel-arrow--next" aria-label="Next">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 5.5L14.5 11L7.5 16.5L7.5 5.5Z"/>
          </svg>
        </button>
      `

      legend.appendChild(navContainer)

      const prevBtn = navContainer.querySelector('.swatch-carousel-arrow--prev')
      const nextBtn = navContainer.querySelector('.swatch-carousel-arrow--next')

      // Scroll amount (width of one swatch + gap)
      const scrollAmount = 58 // approximately 5rem + 0.8rem gap

      const updateButtonStates = () => {
        const isAtStart = row.scrollLeft <= 0
        const isAtEnd = row.scrollLeft >= row.scrollWidth - row.clientWidth - 1
        const hasOverflow = row.scrollWidth > row.clientWidth

        // Hide entire nav container if no scrolling is needed
        navContainer.style.display = hasOverflow ? 'flex' : 'none'

        prevBtn.disabled = isAtStart
        nextBtn.disabled = isAtEnd
      }

      // Initial state check (with small delay to ensure layout is calculated)
      setTimeout(updateButtonStates, 50)
      updateButtonStates()

      // Event listeners
      prevBtn.addEventListener('click', () => {
        row.scrollBy({ left: -scrollAmount, behavior: 'smooth' })
      })

      nextBtn.addEventListener('click', () => {
        row.scrollBy({ left: scrollAmount, behavior: 'smooth' })
      })

      // Update button states on scroll
      row.addEventListener('scroll', updateButtonStates)

      // Also update on resize
      window.addEventListener('resize', updateButtonStates)
    })
  }

  getProductImage(product, option) {
    var image = `<img src="${product.featured_image}" loading="lazy">`
    if (option == 'colour') {
      switch (this.settings.image_type) {
        case 'metafield_image':
          const metafieldImage = product.swatch_image
          if (metafieldImage) image = metafieldImage
          break
        case 'metafield_colour':
          const metafieldColor = product.swatch_color
          if (metafieldColor) image = `<span class="swatch" style="background-color:${metafieldColor}"></span>`
          break
        case 'image_swatch':
          const colourTag = product.colour
          if (colourTag) {
            const colour = colourTag.toLowerCase().replace(/ /g, '').replace(/ /g, '-').toLowerCase()
            image = `<span data-option-name="color" data-colour-${colour.toLowerCase()}> </span>`
          } else {
            image = ``
          }
          break
        case 'featured_image':
          const featuredImage = product.featured_image
          if (featuredImage) image = `<img src="${featuredImage}" loading="lazy">`
          break
        case 'first_variant_image':
          const firstVariantImage = product.variants[0].image
          if (firstVariantImage) image = `<img src="${firstVariantImage}" loading="lazy">`
          break
        case 'last_variant_image':
          const lastVariantImg = product.variants[product.variants.length - 1].image
          if (lastVariantImg) image = `<img src="${lastVariantImg}" loading="lazy">`
          break
        default:
          break
      }
    } else {
      return product[`${option}`]
    }
    return image
  }

  setCurrent(handle) {
    var elements = this.container.querySelectorAll(`[data-handle="${handle}"]`)
    if (handle && elements.length) {
      elements.forEach((element) => {
        element.classList.add('selected')
      })
    }
  }

  formatLabel(value) {
    if (!value) return ''
    return value
      .toString()
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  customElements.define('product-swatches', ProductSwatches)
})

/* Global addToCart function */
/*
window.addToCart = async function(variantId, quantity = 1) {
  if (!variantId) {
    return Promise.reject(new Error('Variant ID is required'))
  }

  const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification')
  
  const sectionsToRender = cart && typeof cart.getSectionsToRender === 'function' 
    ? cart.getSectionsToRender() 
    : []
  
  const formData = new FormData()
  formData.append('id', variantId)
  formData.append('quantity', quantity)
  
  if (sectionsToRender.length > 0) {
    formData.append('sections', sectionsToRender.map((section) => section.id))
    formData.append('sections_url', window.Shopify?.routes?.root || '/')
  }
  
  if (cart && typeof cart.setActiveElement === 'function') {
    cart.setActiveElement(document.activeElement)
  }
  
  const config = fetchConfig('javascript')
  config.headers['X-Requested-With'] = 'XMLHttpRequest'
  delete config.headers['Content-Type']
  config.body = formData
  
  try {
    const response = await fetch(routes.cart_add_url, config)
    const data = await response.json()
    
    if (data.status) {
      throw new Error(data.description || data.message)
    }
    
    if (cart && typeof cart.renderContents === 'function') {
      cart.renderContents(data)
    }
    
    if (cart && cart.classList.contains('is-empty')) {
      cart.classList.remove('is-empty')
    }
    
    return data
  } catch (error) {
    console.error('addToCart error:', error)
    throw error
  }
}
*/

// Global Quick Add for Searchspring integration
window._searchspringReady = false
document.addEventListener('searchspring.domReady', function () {
  window._searchspringReady = true
})

window.openQuickAdd = function (productUrl) {
  if (!productUrl) {
    return Promise.reject(new Error('Product URL is required'))
  }

  let normalizedUrl = productUrl
  try {
    if (productUrl.includes('://')) {
      normalizedUrl = new URL(productUrl).pathname
    } else if (productUrl.startsWith('www.')) {
      normalizedUrl = '/' + productUrl.split('/').slice(1).join('/')
    }
    if (!normalizedUrl.startsWith('/')) {
      normalizedUrl = '/' + normalizedUrl
    }
  } catch (e) {}

  const tryOpenQuickAdd = () => {
    let quickAddModal = document.querySelector('quick-add-modal')
    if (!quickAddModal) return false

    if (quickAddModal.parentElement !== document.body) {
      if (typeof customElements.upgrade === 'function') {
        customElements.upgrade(quickAddModal)
      }
      document.body.appendChild(quickAddModal)
    }

    if (typeof quickAddModal.show !== 'function') return false

    const tempOpener = document.createElement('button')
    tempOpener.setAttribute('data-product-url', normalizedUrl)
    tempOpener.style.display = 'none'
    document.body.appendChild(tempOpener)

    try {
      quickAddModal.show(tempOpener)
      setTimeout(() => tempOpener.remove(), 100)
      return true
    } catch (error) {
      tempOpener.remove()
      return false
    }
  }

  if (tryOpenQuickAdd()) {
    return Promise.resolve()
  }

  if (window._searchspringReady) {
    return new Promise((resolve) => {
      setTimeout(() => {
        tryOpenQuickAdd()
        resolve()
      }, 100)
    })
  }

  return new Promise((resolve) => {
    let handled = false

    const onReady = () => {
      if (handled) return
      handled = true
      document.removeEventListener('searchspring.domReady', onReady)
      tryOpenQuickAdd()
      resolve()
    }

    document.addEventListener('searchspring.domReady', onReady)

    setTimeout(() => {
      if (handled) return
      handled = true
      document.removeEventListener('searchspring.domReady', onReady)
      tryOpenQuickAdd()
      resolve()
    }, 2000)
  })
}

window.addToCart = window.openQuickAdd

/**
 * Global Add Items to Cart Function for Searchspring integration
 *
 * Usage: window.addBundleItemsToCart(items)
 * @param {Array} items - Array of objects with { id: variantId, quantity: number }
 * @returns {Promise} - Resolves with cart data or rejects with error
 *
 * Example:
 * window.addBundleItemsToCart([
 *   { id: '44516996317419', quantity: 1 },
 *   { id: '46957000360171', quantity: 1 }
 * ])
 */
window.addBundleItemsToCart = async function (items) {
  if (!items || !Array.isArray(items) || items.length === 0) {
    return Promise.reject(new Error('Items array is required'))
  }

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')

  const config = fetchConfig('javascript')
  config.headers['X-Requested-With'] = 'XMLHttpRequest'

  const body = { items }

  if (cart && typeof cart.getSectionsToRender === 'function') {
    body.sections = cart.getSectionsToRender().map((section) => section.id)
    body.sections_url = window.Shopify?.routes?.root || '/'
    if (typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(document.activeElement)
    }
  }

  config.body = JSON.stringify(body)

  try {
    const response = await fetch(routes.cart_add_url, config)
    const responseData = await response.json()

    if (responseData.status) {
      throw new Error(responseData.description || responseData.message)
    }

    if (cart && typeof cart.renderContents === 'function') {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'add-items' })
      }
      cart.renderContents(responseData)
    }

    return responseData
  } catch (error) {
    throw error
  }
}
